"use client";

import { Phone } from "lucide-react";
import {
  INVALID_PHONE_MESSAGE,
  isValidBangladeshiPhoneNumber,
  sanitizeBangladeshiPhoneNumber,
} from "../utils/phone";

interface PhoneNumberInputProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  showIcon?: boolean;
}

export default function PhoneNumberInput({
  id,
  value,
  onChange,
  required = false,
  showIcon = false,
}: PhoneNumberInputProps) {
  const hasError = value.length > 0 && !isValidBangladeshiPhoneNumber(value);
  const errorId = `${id}-error`;

  return (
    <div className="space-y-1.5">
      <div className="relative">
        {showIcon && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400">
            <Phone className="h-4 w-4" />
          </span>
        )}
        <input
          id={id}
          type="text"
          required={required}
          value={value}
          onChange={(event) => onChange(sanitizeBangladeshiPhoneNumber(event.target.value))}
          placeholder="e.g. 01700000000"
          inputMode="numeric"
          autoComplete="tel-national"
          maxLength={11}
          pattern="01[0-9]{9}"
          aria-invalid={hasError}
          aria-describedby={hasError ? errorId : undefined}
          className={`w-full ${showIcon ? "pl-10" : "pl-3"} pr-3 py-2 text-sm rounded bg-zinc-50 dark:bg-zinc-900 border text-zinc-900 dark:text-zinc-100 placeholder-zinc-500 focus:outline-none focus:ring-1 ${
            hasError
              ? "border-red-500 focus:border-red-500 focus:ring-red-500"
              : "border-zinc-200 dark:border-zinc-800 focus:border-indigo-500 focus:ring-indigo-500"
          }`}
        />
      </div>
      {hasError && (
        <p id={errorId} className="text-xs font-medium text-red-500">
          {INVALID_PHONE_MESSAGE}
        </p>
      )}
    </div>
  );
}
